<template>
  <component
    :is="componentType[component].value"
    v-model="visible"
    :visible="visible"
    :title="title"
    v-bind="componentType[component].prop"
    :confirm-loading="subLoading"
    class="siteModal"
    @cancel="onCancel"
    @ok="onSubmit"
    @close="onClose"
  >
    <a-form-model
      ref="infoForm"
      class="form-content"
      :model="form"
      :rules="CREATERULE"
    >
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            v-bind="formAttr"
            label="站点名称"
            prop="stationName"
          >
            <a-input
              v-model="form.stationName"
              :max-length="100"
              placeholder="请输入地址名称"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            v-bind="formAttr"
            label="联系人姓名"
            prop="contacts"
          >
            <a-input
              v-model.trim="form.contacts"
              :max-length="30"
              placeholder="请输入联系人姓名"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            v-bind="formAttr"
            label="联系人电话"
            prop="telPhone"
          >
            <a-input
              v-model="form.telPhone"
              :max-length="200"
              placeholder="多个电话用;隔开"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            v-bind="formAttr"
            label="自定义编码"
          >
            <a-input
              v-model="form.customerStationCode"
              :max-length="30"
              placeholder="请输入自定义编码"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            v-bind="formAttr"
            label="类型"
            prop="stationType"
          >
            <a-select
              v-model="form.stationType"
              :get-popup-container="node=>node.parentNode"
              placeholder="请选择地址类型"
              @change="handleChangeType('stationType')"
            >
              <a-select-option
                v-for="item in STATIONTYPELIST"
                :key="item.value"
                :value="item.value"
              >
                {{item.label}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col v-if="form.stationType!==0&&form.stationType" :span="12">
          <a-form-model-item
            v-bind="formAttr"
            label="经营模式"
            prop="businessModel"
          >
            <a-select
              v-model="form.businessModel"
              :get-popup-container="node=>node.parentNode"
              placeholder="请选择经营模式"
              :allow-clear="true"
              @change="handleChangeType('businessModel')"
            >
              <a-select-option
                v-for="item in businessModelType"
                :key="item.value"
                :value="item.value"
              >
                {{item.label}}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
         <a-col v-if="form.stationType!==0&&form.stationType&&form.businessModel!=='PROPRIETARY'&&form.businessModel" :span="12">
          <a-form-model-item
            v-bind="formAttr"
            prop="mainCreditCode"
          >
            <span slot="label">经营主体
              <a-tooltip>
                <template #title>允许站点使用该主体的认证信息生成电子回单</template>
                <i class="el-icon-warning"></i>
              </a-tooltip>
            </span>
             <a-select
              v-model="form.mainCreditCode"
              placeholder="请选择经营主体"
              show-search
              :allow-clear="true"
              :get-popup-container="node=>node.parentNode"
              :filter-option="false"
            >
              <a-select-option v-for="item in mainList" :key="item.creditCode" >
                {{ item.enterpriseName }}<span class="assist">({{ item.creditCode }})</span>
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            v-bind="formAttr"
            label="线路标识"
          >
            <a-input
              v-model="form.preLineIdent"
              :max-length="30"
              placeholder="请输入线路标识"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="12">
          <a-form-model-item
            v-bind="formAttr"
            label="服务商"
            prop="ownerTenantId"
          >
            <a-select
              v-model="form.ownerTenantId"
              :disabled="isEdit"
              placeholder="请选择服务商"
              show-search
              :get-popup-container="node=>node.parentNode"
              :filter-option="false"
              :not-found-content="loading.onTenantSearch ? undefined : null"
              @search="onTenantSearch"
            >
              <a-select-option v-for="item in tenantList" :key="item.ownerTenantId" >
                {{ item.ownerTenantName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            v-bind="formAttr"
            label="状态"
            prop="status"
          >
            <a-radio-group v-model="form.status" class="status">
              <a-radio
                v-for="item in STATUSLIST"
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24">
          <a-form-model-item
            v-bind="formAttr"
            label="收货时段"
            prop="time"
          >
            <div v-for="(item, index) in form.receiptPeriod" :key="index" style="margin-bottom: 12px">
              <a-time-picker v-model="item.startTime" format="HH:mm" />
              -
              <a-time-picker v-model="item.endTime" format="HH:mm" />
              <a-button v-if="index < 9 && form.receiptPeriod.length < 10" type="primary" size="small" style="margin-left: 12px" @click="onAdd(index)">添加</a-button>
              <a-button v-if="index > 0" style="margin-left: 12px" size="small" @click="onDelete(index)">移除</a-button>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="24" style="position: relative;">
          <a-form-model-item
            v-bind="formAttr"
            label="详细地址"
            prop="address"
          >
            <div class="flex">
              <a-input v-model="form.address" placeholder="请输入详细地址" />
              <a-popover :visible="searchFlag" trigger="click" placement="bottomLeft" @visibleChange="handleClickChange">
                <a-button type="primary" style="margin-left:10px" @click="onPoiSearch">匹配经纬度</a-button>
                <template #content>
                  <ul class="ul">
                    <li v-for="item in poiList" :key="item.id" class="li" @click="handlePoiChange(item)">{{item.address}}</li>
                    <li v-if="!poiList.length" class="center">暂无搜索结果</li>
                  </ul>
                </template>
              </a-popover>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <siteAddressMap :address-info="addressInfo" @clickMap="handleClick">
      <template>
        <span class="latitude_content">
          <span>经度：{{ form.poiExt.lat||form.latitude||'--' }}</span>
          <span>纬度：{{ form.poiExt.lon||form.latitude||'--' }}</span>
        </span>
      </template>
    </siteAddressMap>
    <div v-if="fromOrder" class="drawer_btn">
      <a-button @click="onClose">取消</a-button>
      <a-button type="primary" :loading="subLoading" @click="onSubmit">确定</a-button>
    </div>
  </component>
</template>

<script>
import loadingMixin from "@thales/loading";
import moment from 'moment';
import { EventBus } from '@/utils/event-bus'
import { CREATERULE, STATIONTYPELIST, STATUSLIST,StationTypes,STATUS,BizTypeMap,businessModelType } from '../../const'
import { getTenantList, getPoiList ,createStation,updateStation,getStationDetail,mainManagerListByCustomer} from '../../api'
import siteAddressMap from './siteAddressMap.vue'

const componentType={
  modal:{
    value:'a-modal',
    prop:{
      width:"1040px",
      'mask-closable':false,
      destroyOnClose:true,
    }
  },
  drawer:{
    value:'a-drawer',
    prop:{
      width:"720",
      bodyStyle:{ paddingBottom: '80px' },
      destroyOnClose:true
    }
  }
}
export default {
  name: 'CreateSite',
  components:{
    siteAddressMap,
  },
  mixins: [loadingMixin],
  data() {
    return {
      visible: false,
      subLoading:false,
      title: '',
      form: {
        receiptPeriod: [{}],
      },
      CREATERULE,
      componentType,
      STATIONTYPELIST,
      STATUSLIST,
      businessModelType,
      formAttr: {
        colon: false,
        class: "search_item"
      },
      isEdit: false,
      component:'modal',
      tenantList: [],
      poiList: [],
      fromOrder:false,
      loading: {
        onTenantSearch: false,
        onPoiSearch: false,
      },
      addressInfo:null, // 地图
      mainList:[],
      searchFlag:false,
    }
  },
  methods: {
    onAdd() {
      this.form.receiptPeriod.push({})
    },
    onDelete(index) {
      this.form.receiptPeriod.splice(index, 1)
    },
   async show(stationCode,component, fromOrder = false) {
      this.tenantList=[]
      this.poiList= []
      this.component=component
      this.isEdit = !!stationCode
      this.fromOrder=fromOrder
      this.title = stationCode ? '编辑地址' : '新增地址';
      if(stationCode){
        const res= await getStationDetail({stationCode,needReceipt: true})
        console.log('变价',res)
        const { receiptPeriod, ...reset } = res
        this.form ={
          status: STATUSLIST[0].value,
          stationType: STATIONTYPELIST[0].value,
          poiExt:{},
          ...reset,
          address:res.address||(res.poiExt?res.poiExt.address:undefined),
          businessModel:res.ext?.businessModel||null,
          mainCreditCode:res.ext?.mainCreditCode||null,
        }
        this.addressInfo=res.poiExt?res.poiExt:{}
        if (res.ext === '{}' || !res.ext) {
          this.form.ext = {
            lineId: null,
            pathName: '',
          };
        }
        if (res.receiptPeriod?.length) {
          this.$set(this.form, 'receiptPeriod', receiptPeriod.map(item => ({
            startTime: item.startTime ? moment(item.startTime, 'HH:mm') : null,
            endTime: item.endTime ? moment(item.endTime, 'HH:mm') : null,
          })))
        } else {
          this.$set(this.form, 'receiptPeriod', [{}])
        }
      } else {
        this.form ={
        status: STATUSLIST[0].value,
        stationType: STATIONTYPELIST[1].value,
        poiExt:{},
        receiptPeriod: [{}],
        }
        this.addressInfo={}
      }
      // 如果是从订单站点中新建，需要把服务商信息带出来
      if (fromOrder) {
        // this.isEdit = true
        this.onTenantSearch()
      } else {
        this.onTenantSearch()
      }
      this.handleSearchMain()
      this.visible = true;
    },
   async update(stationCode,data){
      const userInfo=this.$store.state.user
      const res= await getStationDetail({stationCode,needReceipt: true})
      await updateStation({
        ...res,
        status:data,
        updatedUserName:userInfo.realName,
        updatedTelPhone:userInfo.mobile
      })
      this.$message.success(`${res.status===0?'启用':'停用'}成功`)
      this.$emit('refresh')
    },
    handlePoiChange(val) {
      const arr=this.poiList.filter(item=>item.id===val.id);
      this.form.address=val.address;
      this.form.poiExt={
        ...arr[0],
      }
      EventBus.$emit('selectAddress',this.form.poiExt)
      this.searchFlag=false;
    },
    async onPoiSearch() {
      this.poiList = await getPoiList({
        address: this.form.address
      })
    },
    handleClickChange(val){
      this.searchFlag=val
    },
    async onTenantSearch(val) {
      const {customerCode} = this.$store.state.user
      this.tenantList = await getTenantList({
        customerNameLike: val,
        customerCode
      })
    },
    onClose(){
      this.visible = false;
    },
     onSubmit() {
      const userInfo=this.$store.state.user
      this.$refs.infoForm.validate(async valid => {
        if (valid) {
          const {address,ownerTenantId,stationName,receiptPeriod,...restParmas}=this.form
          const tenant=this.tenantList.filter(item=>item.carrierTenantId===ownerTenantId)[0]
          const {city,cityCode,county,countyCode,id,province,provinceCode}=this.form.poiExt
          const {accountName,customerCode,customerId,userId,userName} = this.$store.state.user
          let notComplete = false
          let isErr = false
          receiptPeriod.forEach(item => {
            const {startTime, endTime} = item || {}
            if ((startTime && !endTime) || (endTime && !startTime)) {
              notComplete = true
            }
            if (startTime > endTime) {
              isErr = true
            }
          })
          if (notComplete) {
            this.$message.warning('请选择完整的收货时段')
            return
          }
          if (isErr) {
            this.$message.warning('结束时间不能早于开始时间')
            return
          }
          this.subLoading=true
          const data={
            ...restParmas,
            provinceCode,
            cityCode,
            cityName:city,
            address:this.form.address||this.form.poiExt.origAddress||this.form.poiExt.address,
            countyName:county,
            countyCode,
            stationName:stationName || this.form.poiExt.origAddress,
            poiId:id,
            provinceName:province,
            customerCode,
            customerId,
            customerName:accountName,
            operatorId:userId,
            operatorName:userName,
            operatorTenantId:tenant.ownerTenantId,
            operatorTenantName:tenant.ownerTenantName,
            updatedUserName:userInfo.realName,
            updatedTelPhone:userInfo.mobile
          }
          const timeList = []
          receiptPeriod.forEach(item => {
            if (item.startTime && item.endTime) {
              timeList.push({
                startTime: item.startTime ? moment(item.startTime).format('HH:mm') : null,
                endTime: item.endTime ? moment(item.endTime).format('HH:mm') : null,
              })
            }
          })
          data.ext = {
            ...data.ext || {},
            receiptPeriod: timeList
          }
          try {
            if(this.isEdit){
            const { stationType } = data;
            data.stationType = StationTypes[stationType];
            data.extStatus =STATUS[data.status];
            data.changedChannel = 'CUSTOMER_STATION_MANAGE';
            await updateStation(data)
            this.$message.success('更新成功')
          }else {
            data.bizType=BizTypeMap.TRANSPORT_WAREHOUSE
            await createStation(data)
            this.$message.success('创建成功')
          }
          this.visible = false;
          this.subLoading=false
          this.$emit('refresh')
          } catch (error) {
          this.subLoading=false
          }
        }
      })
    },
    onCancel() {
      this.visible = false;
      this.$refs.infoForm.resetFields()
    },
    // 地图点击
   async handleClick(info){
     const [res]= await getPoiList({lon:info.lng,lat:info.lat,size:1})
     this.$set(this.form,'address',res.address)
    console.log(info,res);
     this.$set(this.form,'poiExt',res)
    },
    async handleSearchMain(){
      const {customerId} = this.$store.state.user
      const res = await mainManagerListByCustomer({customerId})
      this.mainList = [...res];
    },
    handleChangeType(prop){
      if(prop==='stationType'&&this.form[prop]===0){
        this.$set(this.form,'businessModel',undefined)
        this.$set(this.form,'mainCreditCode',undefined)
      }
      if(prop==='businessModel'&&(this.form[prop]==='PROPRIETARY'||!this.form[prop])){
         this.$set(this.form,'mainCreditCode',undefined)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.search_item  {
  width: 100%;
  margin-bottom: 20px;
  margin-left: 40px;
  /deep/.ant-form-item-control-wrapper {
    width: calc(100% - 80px);
    .ant-form-item-control {
      line-height: 1 !important;
    }
  }
  /deep/ .ant-form-item-label {
    line-height: 17px;
    margin-bottom: 8px;
  }
}
.drawer_btn {
  background: #fff;
  border-top: 1px solid #ccc;
  position:absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  text-align: right;
  padding:20px 0;
  z-index: 501;
  button {
    margin-right: 24px;
  }
}
.status{
  .ant-radio-wrapper {
    height: 32px;
    line-height: 30px;
  }
  label:last-child{
    margin-right: 0;
  }
}
.siteModal {
  /deep/.ant-modal {
    width: 800px !important;
    .ant-modal-body {
      padding: 24px 0;
    }
  }
  /deep/.ant-drawer-title {
    font-weight: 700;
  }
  /deep/ .ant-drawer-body {
    padding: 24px 0 80px 0;
  }
}
.form-content {
   /deep/.ant-form-item-label label{
    color: #606266;
  }
  /deep/.ant-form-item-control-wrapper input{
    color: #171717;
  }
  /deep/.ant-select-enabled .ant-select-selection-selected-value {
    color: #171717;
  }

}
.assist{
  font-size: 12px;
  color: #ccc;
}

.flex{
  display: flex;
}
.ul{
  width: 610px;
  max-height: 320px;
  overflow: auto;
  .li{
    height: 32px;
    line-height: 32px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding:0 12px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .center{
    text-align: center;
    padding: 20px 0;
  }
  .li:hover{
    background: #f0f0f0;
  }
  .active{
    color:#06b880;
  }
  .active:hover{
    background: #fff;
  }
}
.latitude_content{
  margin-bottom: 12px;
  display: inline-flex;
  align-items: center;
  span{
    margin-right: 12px;
    display: inline-flex;
  }
}
</style>
